export enum REST_API_CONTROLLER {
  USER_ADMIN = 'user_admin',
  PSP_ADMIN = 'psp_admin',
  EWALLET_ADMIN = 'wallet_admin',
  WALLET_OPERATION_ADMIN = 'walletOperation_admin',
  TRADING_ACCOUNT_ADMIN = 'tradingAccount_admin',
  TRADING_SERVER_ADMIN = 'tradingServer_admin',
  COMPONENT_ADMIN = 'component_admin',
}

export enum REST_API_METHOD {
  GET_UNMASKED = 'getUnmasked',
  UPDATE_UNMASKED = 'updateUnmasked',
  GET_WITH_STAFF = 'getWithStaff',
  GRID_WITH_STAFF = 'gridWithStaff',
  GRID_WITH_STAFF_TOTALS = 'gridWithStaffTotals',
  EXPORT_WITH_STAFF = 'exportWithStaff',
  GRID_UNMASKED = 'gridUnmasked',
  EXPORT_UNMASKED = 'exportUnmasked',
  GET_CONFIGURATION_UNMASKED = 'getConfigurationUnmasked',
  SET_CONFIGURATION_UNMASKED = 'setConfigurationUnmasked',
}
